import { useQuery, useQueryClient } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import { useOrgId } from 'hooks/index.js';
import { vodUrl } from '../../../../../client-config.js';

const REFETCH_INTERVAL = 5000;
const UPLOAD_REFETCH_INTERVAL = 1000;
const CREATED = 'created';
const WAITING = 'waiting';
const UPLOADING = 'uploading';
const PROCESSING = 'processing';
const COMPLETED = 'completed';
export const UPLOAD_STATUS = {
  CREATED,
  WAITING,
  UPLOADING,
  PROCESSING,
  COMPLETED,
};

const useUploadStatusQuery = ({ mediaAssetId, vendorUploadId, progress, state }, options) => {
  const firebase = useFirebase();
  const orgId = useOrgId();
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ['uploads', vendorUploadId],
    queryFn: async () => {
      const idToken = await firebase.getIdToken();
      const fetchUrl = new URL(`${vodUrl}/v1/orgs/${orgId}/media-assets/${mediaAssetId}/upload-status`);

      const response = await fetch(fetchUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify({ vendorUploadId, progress, state }),
      });
      const { ok, status } = response;

      if (status === 404) return { data: [] };
      if (!ok) throw new Error({ status });

      return await response.json();
    },
    refetchInterval: (data) => {
      if (!data) return false;
      if (data.state === UPLOADING) {
        return UPLOAD_REFETCH_INTERVAL;
      }
      if ([CREATED, WAITING, PROCESSING].includes(data.state)) {
        return REFETCH_INTERVAL;
      }
      if (data.state === COMPLETED) {
        queryClient.invalidateQueries(['videos', orgId]);
      }
      return false;
    },
    ...options,
  });
};

export default useUploadStatusQuery;
